import { ApplicationInsights } from '@microsoft/applicationinsights-web';

/**
 * Every failure inside the version-reload process is swallowed and reported here, never thrown:
 * a console error for anyone looking at the browser, and an Application Insights exception so it
 * shows up in telemetry. The App Insights instance is optional so the library never depends on
 * telemetry being configured.
 */
export function reportVersionReloadProblem(appInsights: ApplicationInsights | null, message: string, error?: unknown, properties?: Record<string, string>) {
  const text = `[version-reload] ${message}`;
  console.error(text, error ?? '', properties ?? '');
  try {
    const exception = error instanceof Error ? error : new Error(text);
    appInsights?.trackException({ exception, properties: { source: 'version-reload', message, ...properties } });
  } catch {
    // Telemetry must never break the app.
  }
}
